"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Button;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const styles = react_native_1.StyleSheet.create({
    button: {
        alignItems: 'center',
        borderRadius: 4,
        flexDirection: 'row',
        justifyContent: 'center',
        userSelect: 'none'
    },
    buttonSolid: {
        padding: 8
    },
    buttonOutline: {
        borderWidth: 1,
        padding: 7
    },
    buttonText: {
        fontWeight: '500',
        textAlign: 'center'
    },
});
;
function Button(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    let options = {
        color: props.color ?? THEME.Primary,
        backgroundColor: props.backgroundColor ?? THEME.ButtonBackground,
        disabled: props.disabled ?? false,
        onPress: props.onPress ?? (() => null),
        dismissKeyboardOnPress: props.dismissKeyboardOnPress ?? true,
        type: props.type ?? 'solid',
        textColor: props.textColor,
        textSize: props.textSize ?? 16,
        extraPadding: props.extraPadding
    };
    if (!options.textColor) {
        switch (options.type) {
            case 'solid':
                options.textColor = THEME.White;
                break;
            case 'outline':
            case 'borderless':
                options.textColor = options.color;
                break;
        }
    }
    if (options.disabled) {
        options.textColor = THEME.TextDisabled;
        switch (options.type) {
            case 'solid':
                options.color = THEME.SolidButtonDisabled;
                break;
            case 'outline':
                options.backgroundColor = THEME.ButtonDisabled;
                options.color = THEME.ButtonBorderDisabled;
                break;
            case 'borderless':
                options.color = THEME.ButtonDisabled;
                break;
        }
    }
    const handlePress = () => {
        if (options.dismissKeyboardOnPress && react_native_1.Platform.OS === 'android')
            react_native_1.Keyboard.dismiss();
        props.onPress();
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { role: "button", accessible: true, "aria-label": props["aria-label"] ?? props.text ?? '', accessibilityHint: props.accessibilityHint ?? '', disabled: options.disabled, hitSlop: props.hitSlop, onPress: handlePress, style: ({ pressed }) => [
            styles.button,
            (options.type == 'solid') ? styles.buttonSolid : null,
            (options.type == 'solid') ? { backgroundColor: options.color } : null,
            (options.type == 'outline') ? styles.buttonOutline : null,
            (options.type == 'outline') ? { borderColor: options.color, backgroundColor: options.backgroundColor } : null,
            (options.type == 'borderless') ? styles.buttonSolid : null,
            { pointerEvents: props.pointerEvents },
            props.style,
            pressed ? { opacity: 0.6 } : null
        ], children: props.text
            &&
                (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, numberOfLines: props.numberOfLines, ellipsizeMode: props.ellipsizeMode, style: [
                        styles.buttonText,
                        {
                            margin: options.extraPadding,
                            color: options.textColor,
                            fontSize: options.textSize
                        },
                        !!props.textWeight ? { fontWeight: props.textWeight } : null
                    ], children: props.text })
            ||
                props.children }));
}
;
